function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg144Macao(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#496E2D"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M294.273,248.16c-5.402,0-10.53,1.077-15.293,2.79c2.609-5.815,4.358-12.285,4.358-19.193  c0-27.337-27.337-47.841-27.337-47.841s-27.337,20.503-27.337,47.841c0,6.909,1.749,13.378,4.358,19.193  c-4.763-1.713-9.892-2.79-15.293-2.79c-27.337,0-47.841,27.337-47.841,27.337s20.503,27.339,47.841,27.339  c16.028,0,29.698-9.394,38.273-17.17c8.575,7.776,22.245,17.17,38.273,17.17c27.337,0,47.841-27.339,47.841-27.339  S321.611,248.16,294.273,248.16z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "256,123.382 261.648,140.761 279.92,140.761 265.138,151.502 270.782,168.881 256,158.139    241.218,168.881 246.862,151.502 232.08,140.761 250.352,140.761  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "186.513,153.778 197.376,163.56 210.037,156.25 204.092,169.604 214.954,179.388    200.416,177.859 194.47,191.213 191.43,176.915 176.892,175.387 189.551,168.076  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "135.644,204.646 149.944,207.686 157.253,195.025 158.782,209.563 173.08,212.605    159.726,218.551 161.254,233.087 151.472,222.225 138.118,228.171 145.427,215.511  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "325.487,153.778 314.624,163.56 301.964,156.25 307.909,169.604 297.047,179.388    311.584,177.859 317.53,191.213 320.571,176.915 335.11,175.387 322.449,168.076  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "376.356,204.646 362.057,207.686 354.747,195.025 353.219,209.563 338.921,212.605    352.275,218.551 350.747,233.087 360.529,222.225 373.884,228.171 366.574,215.511  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M256,379.382c21.715,0,41.731-7.245,57.788-19.436H198.213   C214.269,372.136,234.285,379.382,256,379.382z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0F0F0"
    },
    d: "M168.288,321.972c3.037,6.951,6.888,13.462,11.412,19.436h152.602   c4.523-5.974,8.375-12.484,11.412-19.436H168.288z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg144Macao);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };